import tippy from 'tippy.js';

/**
 * Add to Cart component
 *
 * @module component-addtocart
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "component-addtocart";

if (!customElements.get(customElements.component)) {
  class addToCartComponent extends HTMLElement {
    /**
     * Add to Cart web component.
     *
     * @constructor
     */
    constructor() {
      super();

      this.placement = this.dataset.placement;
      this.listenToPricePerQuantityEvent();
      this.customLabelContainer = this.querySelector('.custom-labels-container');

      if (this.customLabelContainer) {
        // Set Custom Label Elements
        this.applyLabelsInputLabel = this.querySelector('[for="apply-labels-input"]');
        this.customLabelSelects = this.querySelectorAll('select[name="label-type"]');
      }

      if (this.dataset.handle) {
        window.theme.product
          .loadProduct(this.dataset.handle)
          .then((product) => {
            // this.initSubmitButton(product);
            this.initEvents(product);
            this.initSwatches();
          });
      } else {
        console.log("Missing product handle", this);
      }
    }

    setOptionsIndexes() {
      //console.log("Searching for option labels");
      //console.log(this);
      const optionLabels = this.querySelectorAll(
        ".option-label:not(.hidden), component-swatches:not(.hidden)"
      );
      //console.log({ optionLabels });
      optionLabels.forEach((node, index) => {
        node.setAttribute("data-index", `${index + 1}.`);
      });
    }

    connectedCallback() {
      this.setOptionsIndexes();
      this.addEventListener("index-changed", () => {
        console.log("index-changed");
        this.setOptionsIndexes();
      });
    }

    /**
     * Init component events.
     *
     * @param {object} product Product data.
     * @returns {undefined}
     */
    initEvents(product) {
      let _this = this;
      // On submit add to cart form
      const form = this.getForm();

      //console.log('this:', this);
      //console.log('form:', form);

      if (form) {
        form.addEventListener("submit", (event) => this.onFormSubmit(event));
      }

      // On variant selector ready or change

      let variantSelector = this.getVariantSelector();

      if (variantSelector) {
        variantSelector.addEventListener("ready", () => {
          this.onVariantSelectorReady();
        });

        if (variantSelector.isReady()) {
          this.onVariantSelectorReady();
        }

        variantSelector.addEventListener("variant-change", (event) => {
          this.updatePrice(event.detail.variantId);
          this.updateSwatches(event.detail.variantId);
          this.updateChildComponent("addtocart-button", event.detail.variantId);
        });
      }

      if (this.applyLabelsInputLabel) {
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (mutation.type === 'childList') {
              this.labelApplicationInfo = this.querySelector('.label-application-info');

              if (typeof tippy === 'function') {
                tippy(this.labelApplicationInfo, {
                  content: `
                    <div class="label-application-tip">
                      Select this option if you would like your custom labels to be applied to the products before shipping.
                    </div>
                  `,
                  allowHTML: true,
                });
              }
            }
          });
        });

        observer.observe(this.applyLabelsInputLabel, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true
        });
      }

      if (_this.customLabelSelects) {
        _this.customLabelSelects.forEach((customLabelSelect, index) => {
          customLabelSelect.addEventListener('change', function(event) {
            if (_this.placement === 'product-single') {
              let selectedOption = customLabelSelect.querySelector(`option[value="${customLabelSelect.value}"]`)
              _this.toggleLabelCustomizeButton(selectedOption?.dataset?.sku);
            }
          });
        });
      }
    }

    listenToPricePerQuantityEvent() {
      let _this = this;
      const config = {
        childList: true,
        subtree: true,
      };

      const pricePerQuantityCallback = (mutationsList, observer) => {
        mutationsList.forEach((mutation) => {
          if (
            mutation.type === "childList" &&
            mutation.target.hasAttribute("data-price-quantity")
          ) {
            const breaksContainer = mutation.target.querySelector("div");
            const lastBreak =
              breaksContainer.lastElementChild.querySelector("[data-interval]");
            lastBreak.innerText = `${lastBreak.dataset.min}+`;
            lastBreak.dataset.max = "99999999";
          }
        });
      };

      const pricePerQuantityObserver = new MutationObserver(
        pricePerQuantityCallback
      );
      pricePerQuantityObserver.observe(_this, config);
    }

    /**
     * On variant selector is ready.
     *
     * @returns {undefined}
     */
    onVariantSelectorReady() {
      let variant = this.variantSelector.getVariant();

      // this.updatePrice(variant.id);
      // this.updateSwatches(variant.id);

      // this.updateChildComponent('addtocart-button', variant.id);
    }

    /**
     * Get variant selector element.
     *
     * @returns {undefined}
     */
    getVariantSelector() {
      if (!this.variantSelector) {
        this.variantSelector = this.querySelector(
          'variant-selector[data-handle="' + this.dataset.handle + '"]'
        );
      }

      return this.variantSelector;
    }

    /**
     * Get swatches element.
     *
     * @returns {undefined}
     */
    getSwatchesElement() {
      if (!this.swatchesElement) {
        this.swatchesElement = this.querySelector(
          'component-swatches[data-handle="' + this.dataset.handle + '"]'
        );
      }

      return this.swatchesElement;
    }

    /**
     * Get price element.
     *
     * @returns {undefined}
     */
    getPriceElement() {
      if (!this.priceElement) {
        this.priceElement = this.querySelector(
          'product-price[data-handle="' + this.dataset.handle + '"]'
        );
      }

      return this.priceElement;
    }

    /**
     * Init swatches element.
     *
     * @returns {undefined}
     */
    initSwatches() {
      let swatchesElement = this.getSwatchesElement();

      if (swatchesElement) {
        swatchesElement.addEventListener("swatch-change", (event) => {
          this.getVariantSelector().update(event.detail.variantId);
          const store = this?.parentElement?._x_dataStack[0];
          store.selectedMainSKU = event?.detail?.variant?.sku;
        });
        swatchesElement.addEventListener("swatch-clicked", (event) => {
          this.syncErrorMessage();
          this.hideUnavailableColors(event);
        });
      }
    }

    toggleLabelCustomizeButton(sku) {
      //const labelCustomization = this.querySelector('component-label-customization')
      const store = this.parentElement._x_dataStack[0];
      if (window.theme.label_app_url === '') return;

      // app links
      // https://epackage-navink-bridge-dev.fly.dev/api/v1/iframe-url/
      // https://ibw.url.sv/api/v1/iframe-url/

      if (!sku) {
        // Hide the label
        //labelCustomization?.setAttribute('data-redirect-url', '');
        store.setRedirectUrl("");
      } else {
        // request custom backend to check if the api has an iframe url for this sku
        // if it does, show the label
        fetch(
          `${window.theme.label_app_url}${sku}`
        )
          .then((response) => response.json())
          .then((data) => {
            console.log('label_app_url:', window.theme.label_app_url);
            console.log('sku:', sku);
            console.log('data:', data);

            if (data.redirectUrl) {
              // this.parentElement._x_dataStack[0].redirectUrl = data.redirectUrl;
              store.setRedirectUrl(data.redirectUrl);
              // Show the label
              // set the iframe url as a data attribute
              // labelCustomization?.setAttribute('data-redirect-url', data.redirectUrl);
              // labelCustomization?.classList.remove('hidden');
            } else {
              store.setRedirectUrl("");
              // this.parentElement._x_dataStack[0].redirectUrl = '';
              // labelCustomization?.setAttribute('data-redirect-url', '');
              // labelCustomization?.classList.add('hidden');
            }
          })
          .catch((error) => {
            store.setRedirectUrl("");
            // labelCustomization?.setAttribute('data-redirect-url', '');
            // labelCustomization?.classList.add('hidden');
            // console.error('Error:', error);
          });
      }
    }

    hideUnavailableColors(eventData) {
      if (!eventData) {
        return false;
      }

      // Limit to only main PDP form
      //if (eventData.target.dataset.placement !== 'product-single') {return false}

      let selectedOption = eventData.detail.element;
      let selectedOptionType = selectedOption.dataset.swatchInput;
      let selectedOptionValue = selectedOption.value;

      const productData = eventData.detail.product;
      const hasColorOption = productData.options.some(
        (option) => option.name === "Color"
      );
      const colorOptionPosition =
        productData?.options_by_name["Color"]?.option?.position;

      if (selectedOptionType === "Color") {
        return false;
      }
      if (!hasColorOption) {
        return false;
      }

      // Available Colors
      let relatedVariants = productData.variants.filter((variant) =>
        variant.title.includes(selectedOptionValue)
      );
      let availableColors = [];

      relatedVariants.forEach((variant) => {
        variant.options.forEach((option) => {
          availableColors.push(variant[`option${colorOptionPosition}`]);
        });
      });

      // filter out duplicates
      let uniqueColors = [...new Set(availableColors)];
      if (!uniqueColors.length) {
        return false;
      }

      let colorOptionsContainer = this.querySelector(
        `component-swatches .swatch-option[data-option="Color"]`
      );
      let allColorSwatches =
        colorOptionsContainer.querySelectorAll(".swatch-container");

      allColorSwatches.forEach((colorSwatch) => {
        let currentColorInput = colorSwatch.querySelector("input");
        if (!currentColorInput) {
          return false;
        }

        if (!uniqueColors.includes(currentColorInput.value)) {
          return (colorSwatch.style.display = "none");
        }
        colorSwatch.style.display = "flex";
      });

      this.selectedColorCheck(uniqueColors, colorOptionsContainer);
    }

    selectedColorCheck(uniqueColors, colorOptionsContainer) {
      if (!uniqueColors || !colorOptionsContainer) {
        return false;
      }

      let allColorSwatches =
        colorOptionsContainer.querySelectorAll(".swatch-container");
      let colorArray = [...new Set(allColorSwatches)];
      if (!colorArray.length) {
        return false;
      }

      let selectedColor = colorArray.filter((colorSwatch) =>
        colorSwatch.querySelector("input:checked")
      )[0];
      if (!selectedColor) {
        return false;
      }
      let isHidden = selectedColor.style.display === "none";
      if (!isHidden) {
        return false;
      }

      // Select the first available color
      let firstAvailableColorSwatch = colorOptionsContainer.querySelector(
        '.swatch-container[style="display: flex;"]'
      );
      let colorSwatchLabel =
        firstAvailableColorSwatch.querySelector(".swatch label");
      colorSwatchLabel.click();
    }

    /**
     * Update product price by variant ID.
     *
     * @returns {undefined}
     */
    updatePrice(variantId) {
      let element = this.getPriceElement();

      if (element) {
        element.update(variantId);
      }
    }

    /**
     * Update product swatches by variant Id.
     *
     * @returns {undefined}
     */
    updateSwatches(variantId) {
      let element = this.getSwatchesElement();

      if (element) {
        element.update(variantId);
      }
    }

    /**
     * Update product add to cart button by variant Id.
     *
     * @returns {undefined}
     */
    updateAddtocartButton(variantId) {
      let element = this.querySelector("addtocart-button");

      if (element) {
        element.update(variantId);
      }
    }

    updateChildComponent(selector, variantId) {
      let element = this.querySelector(selector);

      if (element) {
        element.update(variantId);
      }
    }

    getForm() {
      return this.querySelector("form");
    }

    /**
     * Display error message
     *
     * @return {undefined}
     */
    displayErrorMessage(id, qty_added, message_error) {
      let message = this.querySelector("[data-form-error-message]");
      let divMessage = message.querySelector("[data-message]");

      if (!message) return null;

      // Display error message
      if (id == null || qty_added == null) {
        if (divMessage) {
          // Set new size for message
          divMessage.classList.add("text-xs");

          let span = divMessage.querySelector("span");

          if (span) {
            span.innerText = message_error;
            // Show message
            message.classList.remove("hidden");
          }
        }
      }

      // Display error message based on the product
      window.theme.cart
        .get()
        .then((cart) => {
          cart.items.forEach((item) => {
            if (id == item.id) {
              if (divMessage) {
                // Set new size for message
                divMessage.classList.add("text-xs");

                let span = divMessage.querySelector("span");

                if (span) {
                  let productTitle = item.title;

                  if (message_error.message) {
                    span.innerText = message_error.message;
                  } else {
                    // Default Message
                    span.innerText =
                      "Sorry, you can't add more " +
                      productTitle +
                      " to your basket. All available items (" +
                      item.quantity +
                      ") are already in your basket.";
                  }

                  // Show message
                  message.classList.remove("hidden");

                  let input = document.querySelectorAll(
                    '[data-cart-table-item-id="' + item.id + '"]'
                  );

                  if (input) {
                    input.forEach((element) => {
                      element.value = item.quantity;
                    });
                  }

                  // Hide add to cart button
                  let button = this.querySelector("addtocart-button");

                  if (button) {
                    button.classList.add("hidden");
                  }

                  // Hide message after 7 seconds
                  setTimeout(() => {
                    message.classList.add("hidden");
                    span.innerText = "";

                    if (button) {
                      button.classList.remove("hidden");
                    }
                  }, 7000);
                }
              }
            }
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    hideErrorMessage() {
      let message = this.querySelector("[data-form-error-message]");

      if (message) {
        message.classList.add("hidden");
      }
    }

    syncErrorMessage() {
      // if the error message is not visible return
      const errorMessage = this.querySelector(
        "[data-form-error-message]:not(.hidden)"
      );

      if (!errorMessage) return;

      const names = Object.keys(
        Array.from(this.querySelectorAll("[data-swatch-input]"))
          .map((elem) => elem.name)
          .reduce((acc, name) => ({ ...acc, [name]: 1 }), {})
      );
      const missingChecked = names.filter(
        (name) =>
          !this.querySelector(`input[type="radio"][name="${name}"]:checked`)
      );

      console.log({ names, missingChecked });

      if (missingChecked.length) {
        const missingCheckedString =
          missingChecked.length > 1
            ? missingChecked.slice(0, -1).join(", ") +
              " and " +
              missingChecked.slice(-1)
            : missingChecked[0];
        this.displayErrorMessage(
          null,
          null,
          `Please, select a ${missingCheckedString}`
        );
        return;
      }

      this.hideErrorMessage();
    }

    // TODO: Improve this on submit form for other platforms
    onFormSubmit(event) {
      event.preventDefault();

      const form = event.target;
      //console.log('form:', form);

      const formData = new FormData(form);
      //console.log('formData:', formData);

      let properties = {};

      // TODO: Add a validation method in this form.

      if (form.checkValidity() === false) {
        form.reportValidity();
        return;
      }

      for (const [key, value] of formData) {
        let regex = /properties\[[^\]]*\]/i;
        if (regex.test(key) && value != "") {
          let propertyKey = key.replace("properties[", "").replace("]", "");
          properties[propertyKey] = value;
        }
      }

      // Trigger an error if formData.get('id') is empty
      if (
        formData.get("id") == null ||
        formData.get("id") == undefined ||
        formData.get("id") == ""
      ) {
        // find the different [data-swatch-input] elements and extract the different names of the inputs
        const names = Object.keys(
          Array.from(this.querySelectorAll("[data-swatch-input]"))
            .map((elem) => elem.name)
            .reduce((acc, name) => ({ ...acc, [name]: 1 }), {})
        );
        const missingChecked = names.filter(
          (name) =>
            !this.querySelector(`input[type="radio"][name="${name}"]:checked`)
        );
        const missingCheckedString =
          missingChecked.length > 1
            ? missingChecked.slice(0, -1).join(", ") +
              " and " +
              missingChecked.slice(-1)
            : missingChecked[0];
        /*this.displayErrorMessage(
          null,
          null,
          `Please, select a ${missingCheckedString}`
        );*/

        return;
      }

      if (this.dataset.handle) {
        window.theme.product
          .loadProduct(this.dataset.handle)
          .then((product) => {
            if (
              product.variants_metafields != null &&
              product.variants_metafields != undefined &&
              product.variants_metafields != ""
            ) {
              product.variants_metafields.forEach((metafield) => {
                if (metafield.variant_id == formData.get("id")) {
                  console.log(metafield.metafields.min_pack_qty);

                  // Add property to the product
                  properties["Min Pack QTY"] =
                    metafield.metafields.min_pack_qty;
                }
              });
            }

            if (
              product.variants[0].quantity_rule.max != null &&
              product.variants[0].quantity_rule.max != undefined &&
              product.variants[0].quantity_rule.max != "" &&
              formData.get("qty") > product.variants[0].quantity_rule.max
            ) {
              let message =
                "This item has a maximum of " +
                product.variants[0].quantity_rule.max +
                ".";
              let error = { message: message };

              this.displayErrorMessage(
                formData.get("id"),
                formData.get("qty"),
                error
              );
            } else {
              window.theme.cart
                .add(
                  formData.get("id"),
                  formData.get("qty"),
                  properties,
                  true,
                  formData
                )
                .then((result) => {})
                .catch((error) => {
                  // TODO: Display the error message in the frontend.
                  console.log(error.message);

                  // Display error message
                  this.displayErrorMessage(
                    formData.get("id"),
                    formData.get("qty"),
                    error
                  );
                });
            }
          });
      }
    }

    loading() {
      let button = this.querySelector("addtocart-button");

      button.loading();

      this.disable();
    }

    disable() {
      this.querySelector("variant-selector").disable();
      this.querySelector("component-swatches").disable();
    }

    enable() {
      let button = this.querySelector("addtocart-button");

      button.enable();

      this.querySelector("variant-selector").enable();
      this.querySelector("component-swatches").enable();
    }

    // TODO: Implement a validation method
    validateFieldRequired(form) {
      const fields = form.querySelectorAll("[required]");

      let foundError = false;

      for (let field of fields) {
        foundError = field.validity.valueMissing;

        if (foundError) {
          field.classList.add("invalid");
        }
      }

      return foundError;
    }
  }

  customElements.define(customElements.component, addToCartComponent);
}
